import isEqual from 'lodash/isEqual';
import { IFilterConfig } from './config-report.interface';

export function isIgnoredValue(filterItem: IFilterConfig, value: any): boolean {
  return filterItem.ignoredValues?.find(ignoredValue => isEqual(ignoredValue, value));
}

export function isDataNull(data: any): boolean {
  return data === null || data === undefined || data === '';
}

export enum REPORTS_ERROR_CODE {
  INVALID_FILTER_CONFIG = 'invalid-filter-config',
  INVALID_SUB_REPORT_CONFIG = 'invalid-sub-report-config',
}
